<template>
    <branch-card
    :title="`Branch Transfer Request`"
    :showTitleOnly="true"
    >
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top @click="$router.back()">
          <v-icon left>mdi-arrow-left</v-icon>
          Back
        </v-btn>
        <branch-card :elevation="0" :showTitleOnly="false">
            <v-card-title class="d-flex align-center justify-center subtitle-1 font-weight-medium">
                Student Details
            </v-card-title>
            <student-form
                :enrollmentCode="enrollmentCodeId"
                @setEnrollmentCode="setEnrollmentCode"
                @setOldFranchiseeId="setOldFranchiseeId"
                @setKitReceived="setKitReceived"
                @setStudentDetails="setStudentDetails"
            />
            <div v-if="enrollmentCodeId">
                <v-card-title class="d-flex align-center justify-center subtitle-1 font-weight-medium">
                    Branch Transfer Center Details
                </v-card-title>
                <BranchTransferCenterDetails
                  :studentDetails="studentDetails"
                  :enrollmentCodeId="enrollmentCodeId"
                  :oldFranchiseeId="oldFranchiseeId"
                  :monthData.sync="monthData"
                  @setNewFranchiseeId="setNewFranchiseeId"
                  @setExitDate="setExitDate"
                  @setNewJoiningDate="setNewJoiningDate"
                  @setNewFeePlan="setNewFeePlan"
                  @reset="reset"
                />
            </div>
            <div v-if="financeTemplateDetails">
                <v-card-title class="d-flex align-center justify-center subtitle-1 font-weight-medium">
                    Branch Transfer Center Details
                </v-card-title>
                <BranchTransferFinanceDetails
                  :finance="financeTemplateDetails"
                  :exitDate="exitDate"
                  :newJoiningDate="newJoiningDate"
                  :newFeePlan="newFeePlan"
                />
                <v-card-actions class="mt-4 d-flex justify-end">
                    <!-- <v-btn class="mr-4" small dense>Cancel</v-btn> -->
                    <v-btn color="accent" @click="createNewBranchTransferRequest" small dense>Submit</v-btn>
                </v-card-actions>
            </div>
        </branch-card>
    </branch-card>
</template>
<script>
import constants from '@/utils/constants'
import BranchCard from '@/components/BranchTransferV1/component/branchCardComponent'
import StudentForm from '@/components/BranchTransferV1/component/form/studentFormComponent'
import BranchTransferCenterDetails from '@/components/BranchTransferV1/component/form/branchTransferDetailsFormComponent'
import BranchTransferFinanceDetails from '@/components/BranchTransferV1/component/form/financeDetailsComponent'
export default {
  name: 'BranchInitiateFormComponent',
  props: ['enrollmentCode'],
  components: {
    BranchCard,
    StudentForm,
    BranchTransferCenterDetails,
    BranchTransferFinanceDetails
  },
  data () {
    return {
      enrollmentCodeId: null,
      oldFranchiseeId: null,
      newFranchiseeId: null,
      financeTemplateDetails: null,
      exitDate: null,
      newJoiningDate: null,
      isKitReceived: false,
      monthData: null,
      studentDetails: null,
      newFeePlan: null
    }
  },
  created () {
    if (this.enrollmentCode) {
      this.enrollmentCodeId = this.enrollmentCode
    }
  },
  watch: {
    newFeePlan: function (newVal, oldVal) {
      this.callFinanceDetailsApi()
    },
    newFranchiseeId: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.callFinanceDetailsApi()
      }
    },
    exitDate: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.callFinanceDetailsApi()
      }
    },
    newJoiningDate: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.callFinanceDetailsApi()
      }
    },
    enrollmentCodeId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.financeTemplateDetails = null
        this.monthData = null
      }
    },
    monthData: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.callFinanceDetailsApi(1)
      }
    }
  },
  methods: {
    setEnrollmentCode: function (newVal) {
      this.enrollmentCodeId = newVal
    },
    setStudentDetails (newVal) {
      this.studentDetails = newVal
    },
    setKitReceived: function (newVal) {
      this.isKitReceived = newVal
    },
    setOldFranchiseeId: function (newVal) {
      this.oldFranchiseeId = newVal
    },
    setNewFranchiseeId: function (newVal) {
      this.newFranchiseeId = newVal
      this.financeTemplateDetails = null
      this.monthData = null
    },
    setExitDate: function (newVal) {
      this.exitDate = newVal
      this.monthData = null
    },
    reset: function () {
      this.financeTemplateDetails = null
      this.monthData = null
    },
    setNewJoiningDate: function (newVal) {
      this.newJoiningDate = newVal
      this.monthData = null
    },
    setNewFeePlan: function (newVal) {
      this.newFeePlan = newVal
      this.financeTemplateDetails = null
      this.monthData = null
    },
    callFinanceDetailsApi: function (flag) {
      if (this.enrollmentCodeId && this.newFranchiseeId && this.exitDate && this.newFeePlan && this.newJoiningDate) {
        this.getFinanceDetailsData(flag)
      } else {
        this.financeTemplateDetails = null
        this.monthData = null
      }
    },
    getFinanceDetailsData: async function (flag = 0) {
      try {
        if (!this.enrollmentCodeId) {
          return this.errMsg('Enrollment code required.')
        }
        if (!this.oldFranchiseeId) {
          return this.errMsg('Old franchisee required.')
        }
        if (!this.newFranchiseeId) {
          return this.errMsg('New franchisee required.')
        }
        if (!this.newFeePlan) {
          return this.errMsg('Fee plan is required.')
        }
        if (!this.exitDate) {
          return this.errMsg('Exit date is required.')
        }
        if (!this.newJoiningDate) {
          return this.errMsg('New joining date is required.')
        }
        let sum = (this.monthData?.franchisee?.old || 0) + (this.monthData?.franchisee?.new || 0)
        if (sum > 12) {
          this.financeTemplateDetails = null
          return this.errMsg('Total months cannot be more than 12.')
        }
        let payload = {}
        payload.enrollmentCode = this.enrollmentCodeId
        payload.oldFranchiseeID = this.oldFranchiseeId
        payload.newFranchiseeID = this.newFranchiseeId
        payload.oldSchoolLastDate = this.exitDate
        payload.expectedJoiningDate = this.newJoiningDate
        payload.feePlanID = this.newFeePlan.id

        payload.oldCentreMonths = this.monthData?.franchisee?.old
        payload.newCentreMonths = this.monthData?.franchisee?.new
        payload.applicableMonths = this.monthData?.applicableMonths || 1

        let res = await http.post(`${constants.API_URL}/api/v1/branch-transfer/get-student-finance-details`, payload)
        if (res.status === 200) {
          this.financeTemplateDetails = res.data || null
          if (!flag) {
            this.monthData = this.financeTemplateDetails?.financeDetails?.find(item => item.fieldType === 'monthCompleted')
          }
          // this.updateFinanceWithFeePlan()
        } else {
          this.financeTemplateDetails = null
          this.monthData = null
        }
      } catch (e) {
        this.financeTemplateDetails = null
        this.monthData = null
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    createNewBranchTransferRequest: async function () {
      try {
        if (!this.exitDate) {
          this.errMsg('Please provide expected last date for current school.')
          return
        }
        if (!this.newJoiningDate) {
          this.errMsg('Please provide expected joining date for new school.')
          return
        }
        // if (!this.isKitReceived) {
        //   this.errMsg('Please select student kit received by parent.')
        //   return
        // }
        if (!this.newFeePlan) {
          this.errMsg('Please select fee plan')
          return
        }

        let payload = {}

        payload.newCenterFeeplanId = this.newFeePlan.id
        payload.enrollmentCode = this.enrollmentCodeId
        payload.oldFranchiseeID = this.oldFranchiseeId
        payload.newFranchiseeID = this.newFranchiseeId
        payload.lastDateOfOldFranchisee = this.exitDate
        payload.joiningDateOfNewFranchisee = this.newJoiningDate
        payload.applicableMonths = this.monthData?.applicableMonths || 1
        payload.isKitReceived = !!this.isKitReceived

        this.financeTemplateDetails.financeDetails.forEach(item => {
          if (item.fieldType === 'feeDetails') {
            payload.oldCenterTotalFee = item.franchisee.old
            payload.newCenterTotalFee = item.franchisee.new
            payload.oldCenterTotalPaidAmount = item.parent.old
            payload.oldFeePlanName = item.lable
          }
          if (item.fieldType === 'entryDate') {
            payload.joiningDateOfOldFranchisee = item.franchisee.old
          }
          if (item.fieldType === 'exitDate') {
            payload.newCenterYearEndDate = item.franchisee.new
          }
          if (item.fieldType === 'monthCompleted') {
            payload.oldCenterCompletedMonths = item.franchisee.old
            payload.newCenterMonths = item.franchisee.new
          }
          if (item.fieldType === 'feeToBeCollected') {
            payload.oldFeeTobeCollectedAmount = item.franchisee.old
            payload.newFeeTobeCollectedAmount = item.franchisee.new
          }
          if (item.fieldType === 'franchiseeToParent') {
            payload.oldFranchiseetoParentAmount = item.franchisee.old
            payload.newFranchiseetoParentAmount = item.franchisee.new
          }
          if (item.fieldType === 'parentToFranchisee') {
            payload.oldParenttoFranchiseeAmount = item.franchisee.old
            payload.newParenttoFranchiseeAmount = item.franchisee.new
          }
        })

        let res = await http.post(`${constants.API_URL}/api/v1/branch-transfer/create-branch-transfer-request`, payload)

        if (res.status === 200) {
          this.okMsg('New Branch Request Created.')
          this.$router.push({ name: 'branchTransferList' })
        } else {
          this.errMsg('Failed to create new branch request.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    }
  }
}
</script>
